import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

export interface AddRaumData {
  sektionId: string;
}

@Component({
  selector: 'app-add-raum-dialog',
  templateUrl: './add-raum-dialog.component.html',
  styleUrls: ['./add-raum-dialog.component.css'],
})
export class AddRaumDialogComponent implements OnInit {
  frmRaum: UntypedFormGroup;
  sektionId: string;

  constructor(
    public dialogRef: MatDialogRef<AddRaumDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddRaumData,
    private _fb: UntypedFormBuilder
  ) {
    this.sektionId = data.sektionId;

    this.frmRaum = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      sektion_id: [this.sektionId]
    });
  }

  ngOnInit() {
    // Form is already initialized in constructor
  }

  onConfirm(): void {
    if (this.frmRaum.valid) {
      this.dialogRef.close({ 
        event: 'create', 
        data: this.frmRaum.value 
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }
}
